import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { chatSlice } from '../../../common/reducers/chat';

export const DocumentVisibilityListener: FC = () => {
  const dispatch = useDispatch();

  const handleVisibilityChange = useCallback(() => {
    dispatch(chatSlice.actions.setIsDocumentVisible(document.visibilityState === 'visible'));
  }, [dispatch]);

  useEffect(() => {
    handleVisibilityChange();
  }, [handleVisibilityChange]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);

  return <></>;
};
